// eslint-disable-next-line import/prefer-default-export
export const selectLoggedInStatus = (store) => store.loggedInStatus;
